module.exports = __webpack_public_path__ + "img/co-investing1.7d32c9c6.svg";